export * from './getBarberByIdOrRouteQuery';
